import { collection, doc, getDoc, onSnapshot, orderBy, query } from 'firebase/firestore';
import Image from 'next/image';
import Input from './Input';
import Post from './Post';
import { useEffect, useState } from 'react';
import { db } from '../firebase';
import { AnimatePresence, motion } from 'framer-motion';
import isocial from '../public/isocial.png';
import { userState } from '../atom/userAtom';
import { useRouter } from 'next/router';
import { useRecoilState } from 'recoil';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
export default function Feed() {
  const [posts, setPosts] = useState([]);

  const router = useRouter();

  const [currentUser, setCurrentUser] = useRecoilState(userState);
  console.log(currentUser);
  const auth = getAuth();

  useEffect(
    () =>
      onSnapshot(
        query(collection(db, 'posts'), orderBy('timestamp', 'desc')),
        (snapshot) => {
          setPosts(snapshot.docs);
        }
      ),
    []
  );
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const fetchUser = async () => {
          const docRef = doc(db, 'users', auth.currentUser.providerData[0].uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setCurrentUser(docSnap.data());
          }
        };
        fetchUser();
      }
    });
  }, []);

  function onSignOut() {
    signOut(auth);
    setCurrentUser(null);
  }
  return (
    <div className="xl:ml-[370px]   border-gray-900  xl:min-w-[576px] sm:ml-[73px] flex-grow max-w-xl select-none ">
      <div className=" flex py-2 px-3 sticky top-0 z-50 bg-gray-900 border-b border-gray-400  ">
        <h2 className="text-lg sm:text-xl font-bold cursor-pointer border-gray-400 text-gray-300">
          Home
        </h2>

        <div className=" animate-[spin_4s_linear_infinite]  flex items-center justify-center px-0 ml-auto w-19 h-8 ms:flex  ">
          <Image width="90" height="90" src={isocial}></Image>
        </div>

        <div className="flex items-center justify-center px-0 ml-auto w-9 h-9  text-white hoverEffect">
          {currentUser ? (
            <>
              <svg
                className=" hover:text-red-600 "
                onClick={onSignOut}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                />
              </svg>
            </>
          ) : (
            <svg
              onClick={() => router.push('/auth/siginin')}
              className=" hover:text-sky-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
              />
            </svg>
          )}
        </div>
      </div>
      <Input />

      <AnimatePresence>
        {posts.map((post) => (
          <motion.dev
            key={post.id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <Post key={post.id} id={post.id} post={post} />
          </motion.dev>
        ))}
      </AnimatePresence>
    </div>
  );
}
